'use strict'

import React from 'react'

var classNames = require('classnames')
var Scroll = require('react-scroll')
var Element = Scroll.Element
var Link = Scroll.Link
var Events = Scroll.Events

var browser = require('./browser')

let navTitle = require('../images/nav_title.svg')
let navButtonIntroduction = require('../images/nav_introduction.svg')
let navButtonStory = require('../images/nav_story.svg')
let navButtonCast = require('../images/nav_cast.svg')
let navButtonStaff = require('../images/nav_staff.svg')
let navButtonComment = require('../images/nav_comment.svg')
let navButtonTheater = require('../images/nav_theater.svg')
let fb = require('../images/facebook.svg')
let tw = require('../images/twitter.svg')

let trailerTitle = require('../images/trailer_title.svg')

let introductionTitle = require('../images/introduction_title.svg')
let introductionText = require('../images/introduction_text.svg')
var introductionScrollStyle = {
  backgroundImage:'url(' + require('../images/introduction_scroll.png') + ')'
}

let storyTitle = require('../images/story_title.svg')
let storyText = require('../images/story_text.svg')
var storyScrollStyle = {
  backgroundImage:'url(' + require('../images/story_scroll.png') + ')'
}

let castTitle = require('../images/cast_title.svg')

let staffTitle = require('../images/staff_title.svg')
var staffScrollStyle = {
  backgroundImage:'url(' + require('../images/staff_scroll.png') + ')'
}

let commentTitle = require('../images/comment_title.svg')
let commentText = require('../images/comment_text.svg')
let specialthanksTitle = require('../images/specialthanks_title.svg')
let specialthanksNames = require('../images/specialthanks_name.svg')

let theaterTitle = require('../images/theater_title.svg')

require('styles//MainScrollContent.less')

class MainScrollContentComponent extends React.Component {
  constructor(props)
  {
    super(props);
    this.state = {
      isMenuAppear:false,
      isNavFixed:false
    }
    browser.init()
  }
  componentDidMount()
  {
    Events.scrollEvent.register('begin', function()
    {
      this.setState({
        isMenuAppear:false
      })
    }.bind(this))
    window.addEventListener('scroll', this.scroll.bind(this))
  }
  componentWillUnmount()
  {
    window.removeEventListener('scroll', this.scroll.bind(this))
  }
  scroll(e)
  {
    var sh;
    if (e.srcElement)
    {
      sh = e.srcElement.body.scrollTop
    }
    else
    {
      sh = e.target.body.scrollTop
    }
    if (sh > window.innerHeight - 66)
    {
      if (!this.state.isNavFixed)
      {
        this.setState({
          isNavFixed:true
        })
      }
    }
    else
    {
      if (this.state.isNavFixed)
      {
        this.setState({
          isNavFixed:false
        })
      }
    }
  }
  render()
  {
    var offset = -66
    if (browser.ua.isMobile || browser.ua.isIOS || browser.ua.isAndroid)
    {
      offset = 0
    }
    var menuCN = classNames({
      'menu':true
    })
    var navCN = classNames({
      'fixed':this.state.isNavFixed
    })
    return (
      <div id='content'>
        <nav id='nav' className={navCN}>
          <div className="inner">
            <h1><img src={navTitle} alt='ハルをさがして LOOKING FOR HARU' /></h1>
            <ul className='sns'>
              <li><a href='https://www.facebook.com/findingharu' target="_blank"><img src={fb} alt='facebook' /></a></li>
              <li><a href='https://twitter.com/lookingforharu' target="_blank"><img src={tw} alt='twitter' /></a></li>
            </ul>
            <ul className={menuCN} >
              <li><Link activeClass='active' to='introduction' spy={true} smooth={true} offset={offset} duration={500} ><img src={navButtonIntroduction} alt='イントロダクション' width='134px' height='auto' /></Link></li>
              <li><Link activeClass='active' to='story' spy={true} smooth={true} offset={offset} duration={500} ><img src={navButtonStory} alt='ストーリー' width='74px' height='auto' /></Link></li>
              <li><Link activeClass='active' to='cast' spy={true} smooth={true} offset={offset} duration={500} ><img src={navButtonCast} alt='キャスト' width='56px' height='auto' /></Link></li>
              <li><Link activeClass='active' to='staff' spy={true} smooth={true} offset={offset} duration={500} ><img src={navButtonStaff} alt='スタッフ' width='57px' height='auto' /></Link></li>
              <li><Link activeClass='active' to='comment' spy={true} smooth={true} offset={offset} duration={500} ><img src={navButtonComment} alt='コメント' width='64px' height='auto' /></Link></li>
              <li><Link activeClass='active' to='theater' spy={true} smooth={true} offset={offset} duration={500} ><img src={navButtonTheater} alt='シアター' width='64px' height='auto' /></Link></li>
            </ul>
          </div>
        </nav>
        <Element id='trailer' name='trailer' className='section'>
          <h2><img src={trailerTitle} alt='TRAILER' /></h2>
          <div className="youtube">
            <iframe width="750" height="424" src="https://www.youtube.com/embed/oDWUEsPbmXw" frameborder="0" allowfullscreen></iframe>
          </div>
        </Element>
        <Element id='introduction' name='introduction' className='section hasScroll'>
          <h2><img src={introductionTitle} alt='INTRODUCTION' /></h2>
          <div className='text'><img src={introductionText} alt='誰にでもきっとある「あの夏の日」' /></div>
          <div className="scroll" style={introductionScrollStyle}></div>
        </Element>
        <Element id='story' name='story' className='section hasScroll'>
          <h2><img src={storyTitle} alt='STORY' /></h2>
          <div className='text'><img src={storyText} alt='あの娘の笑顔を取り戻すため僕らは走る' /></div>
          <div className="scroll" style={storyScrollStyle}></div>
        </Element>
        <Element id='cast' name='cast' className='section transparent'>
          <h2><img src={castTitle} alt='CAST' /></h2>
          <ul className='profiles'>
            <li>
              <p className='img'><img src={require('../images/cast_01.png')} alt='小柴大河（こしばたいが）' /></p>
              <p className='name'><img src={require('../images/cast_01_name.svg')} alt='小柴大河（こしばたいが）' /></p>
              <p className='profile'>１９９９年１２月１０日、東京都生まれ。３才から芸能活動を始める。２００５年に『元泥・助川六郎のご町内防犯パトロール』（フジＴＶ・金曜エンターテインメント）で主人公・六郎の幼少を演じる。本作品ではオーディションで主人公のノボル役を勝ち取る。</p>
            </li>
            <li>
              <p className='img'><img src={require('../images/cast_02.png')} alt='佐藤菜月（さとうなつき）' /></p>
              <p className='name'><img src={require('../images/cast_02_name.svg')} alt='佐藤菜月（さとうなつき）' /></p>
              <p className='profile'>１９９９年２月１７日、静岡県生まれ。２０１３年、第２６回東京国際映画祭・スプラッシュ部門出品作品『楽隊のうさぎ』(監督：鈴木卓彌)にて初出演ながらその存在感が認められ、本作品ではヒロインのチエコ役に抜擢される。</p>
            </li>
            <li>
              <p className='img'><img src={require('../images/cast_03.png')} alt='小泉凱（こいずみがい）' /></p>
              <p className='name'><img src={require('../images/cast_03_name.svg')} alt='小泉凱（こいずみがい）' /></p>
              <p className='profile'>２０００年１月３０日、東京都生まれ。本作で念願の初めての映画出演。オーディションの頃から存在感を示し、本作品ではマサル役を演じる。</p>
            </li>
            <li>
              <p className='img'><img src={require('../images/cast_04.png')} alt='橋本一輝（はしもとかずき）' /></p>
              <p className='name'><img src={require('../images/cast_04_name.svg')} alt='橋本一輝（はしもとかずき）' /></p>
              <p className='profile'>１９９９年８月２８日、千葉県生まれ。TBS 『 浪花少年探偵団』、EX『ハガネの女 Season2 』に 生徒役でレギュラー出演。個性的なキャラクターを活かし、本作品では軍事オタクのヒロキ役を演じる。</p>
            </li>
            <li>
              <p className='img'><img src={require('../images/cast_05.png')} alt='洞口依子（どうぐちよりこ）' /></p>
              <p className='name'><img src={require('../images/cast_05_name.svg')} alt='洞口依子（どうぐちよりこ）' /></p>
              <p className='profile'>１９６５年３月１８日、東京都生まれ。８５年に黒沢清監督の『ドレミファ娘の血は騒ぐ』に主演して女優デビュー。同監督や伊丹十三監督作品で知られ、９２年の「愛という名のもとに」（フジテレビ系）で幅広い人気を獲得した。１６年は１０月２２日に吉田康弘監督『バースデーカード』、秋にマーティン・スコセッシ監督『沈黙』等の公開が控えている。</p>
            </li>
            <li>
              <p className='img'><img src={require('../images/cast_06.png')} alt='小沢仁志（おざわひとし）' /></p>
              <p className='name'><img src={require('../images/cast_06_name.svg')} alt='小沢仁志（おざわひとし）' /></p>
              <p className='profile'>１９６２年６月１９日、東京都生まれ。主な出演作に、『ビー・バップ・ ハイスクール』シリーズ、『SCORE』(95)、『太陽が弾ける日』(07)、『25 NIJYU-GO』(14)などがある。俳優業に留まらず監督・プロデューサーとしても多くの作品を手掛けている。</p>
            </li>
          </ul>
        </Element>
        <Element id='staff' name='staff' className='section hasScroll'>
          <h2><img src={staffTitle} alt='STAFF' /></h2>
          <ul className='profiles'>
            <li>
              <p className='name'><img src={require('../images/staff_01_name.svg')} alt='尾関玄 脚本•監督' /></p>
              <p className='profile'>１９８４年１月生まれ。愛知県春日井市出身。２００６年日本映画学校（現：日本映画大学）卒業。在学中より中学の同級生、内藤諭とISHIOを立ち上げ自主制作映画を制作し始める。以降、数々の商業映画（『麦子さんと』『猫侍』など）の制作に携わる。本作『ハルをさがして』は初めての監督長編作品となる。</p>
            </li>
            <li>
              <p className='name'><img src={require('../images/staff_02_name.svg')} alt='内藤諭 プロデューサー' /></p>
              <p className='profile'>１９８３年１１月生まれ。愛知県春日井市出身。拓殖大学外国語学部中国語学科卒業。以降、フリーの制作部、プロデューサーとして映画、テレビドラマの制作に携わる。プロデューサーとして携わった主な作品として『見えないほどの遠くの空を』（10/榎本憲男監督）台湾ドキュメンタリー映画『湾生回家』（15/黄銘正監督）などがある。</p>
            </li>
            <li>
              <p className='name'><img src={require('../images/staff_03_name.svg')} alt='栗田東次郎 撮影' /></p>
              <p className='profile'>１９８３年２月生まれ。福岡県北九州市出身。三和映材社研修生を経て撮影部となり佐々木原保志カメラマンに師事する。以降『ハナミズキ』、『脳男』、『ばしゃ馬さんとビッグマウス』、『GONINサーガ』等の映画作品に撮影助手として参加する。</p>
            </li>
            <li>
              <p className='name'><img src={require('../images/staff_04_name.svg')} alt='小牧将人 録音' /></p>
              <p className='profile'>１９８６年６月生まれ。東京都府中市出身。日本映画学校（現:日本映画大学）卒業。以降、数々の映画作品に録音技師として参加。主な作品に『あの娘、早くババアになればいいのに』（14/頃安祐良監督）『殺人ワークショップ』（14/白石晃士監督）『いつかの、玄関たちと、』（14/勝又悠監督）『starting over』(14/西原孝至監督) 『森のカフェ』(15/榎本憲男監督)などがある。</p>
            </li>
            <li>
              <p className='name'><img src={require('../images/staff_05_name.svg')} alt='石川真吾 編集' /></p>
              <p className='profile'>１９８３年１０月生まれ。福井県福井市出身。武蔵野美術大学映像学科卒業。監督作『カササギの食卓』で2005年PFFアワード入選、国内外の映画祭で上映される。以降「馬車馬企画」所属。主な参加作品に『見えないほどの遠くの空を』（10/榎本憲男監督）『蘇りの恋』（15/石川真吾監督）『森のカフェ』（15/榎本憲男監督）『リリカルスクールの未知との遭遇』（16/デモ田中監督）などがある。</p>
            </li>
            <li>
              <p className='name'><img src={require('../images/staff_06_name.svg')} alt='遠藤浩二 音楽監督' /></p>
              <p className='profile'>２１歳で廣木光一氏に師事。２４歳から映像音楽に興味を持ち、映画､ＴＶ､ＣＭ､ＶＩＤＥＯ等の作曲アレンジの仕事を始め､２５歳から本格的に作曲へ進む。『十三人の刺客』（10/三池崇史監督）で第３４回日本アカデミー賞優秀音楽賞受賞。主な作品に『土竜の唄 潜入捜査官REIJI』（14）、『テラフォーマーズ』（16）、『とと姉ちゃん』（2016年、NHK連続テレビ小説）などがある。</p>
            </li>
          </ul>
          <div className='themesong'><img src={ require('../images/themesong.svg') } alt='「呼んでくれ」主題歌 作詞•作曲：甲本ヒロト' /></div>
          <div className="scroll" style={staffScrollStyle}></div>
        </Element>
        <Element id='comment' name='comment' className='section'>
          <h2><img src={commentTitle} alt='COMMENT' /></h2>
          <div className='text'><img src={commentText} alt='COMMENT' /></div>
          <div className="specialthanks">
            <h2><img src={specialthanksTitle} alt='SPECIAL THANKS' /></h2>
            <div className="names">
              <img src={specialthanksNames} alt='沼田健彦 永田紘章 小泉　薫 中村裕一 熊谷幸枝 中川美緒 佐藤雅美 渡邊政一 上村清人 佐藤雅美 市村淳一 柳田和晃 鈴木正昭 宮崎典子 吹谷芳博 月橋宏隆 進藤桂子 三原琴実 小岩誠志 増渕典子 鶴岡 剛 山下信弥 若狭真由美 松丸有佳子 森川和昭' />
            </div>
          </div>
        </Element>
        <Element id='theater' name='theater' className='section transparent'>
          <div className="inner">
            <h2><img src={theaterTitle} alt='THEATER' /></h2>
            <p className='info'>
              <div className="new">
                <h3><span>NEW</span></h3>
                <p>シアターセブン<br/>2017年3月25日（土）12:15<br/>2017年3月26日（日）〜3月31日（金）18:50</p>
                <p className="entrance">入場料金</p>
                <dl>
                  <dt></dt>
                  <dd>一般：1500円　大学・専門：1200円<br/>中学・高校生：1000円　シニア：1100円　小学生以下：700円<br/>シアターセブン会員：1000円<br/>その他劇場規定の割引・サービスデーの適用あり</dd>
                </dl>
                <p><a href="http://www.theater-seven.com" target="_blank">http://www.theater-seven.com</a></p>
              </div>
              <div className="past">
                <h3><span>PAST</span></h3>
                <ul>
                  <li>下北沢トリウッド<br/>2016年8月6日（土）〜9月25日（金）</li>
                  <li>名古屋シネマテーク<br/>2016年12月25日（日）〜12月30日（金）</li>
                </ul>
              </div>
            </p>
            <div className="update">劇場情報は随時更新致します。</div>
            <p className='copy'>&copy; 2015 ISHIO</p>
          </div>
        </Element>
      </div>
    )
  }
  menuToggle()
  {
    this.setState({
      isMenuAppear: !this.state.isMenuAppear
    })
  }
}

MainScrollContentComponent.displayName = 'MainScrollContentComponent'

// Uncomment properties you need
// MainScrollContentComponent.propTypes = {}
// MainScrollContentComponent.defaultProps = {}

export default MainScrollContentComponent



/** WEBPACK FOOTER **
 ** ./src/components/MainScrollContentComponent.js
 **/